import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { PRODUCT_TYPES } from '@hero/constants';
import { useSendToApproval } from '@hero/services/organization-service/hooks';
import { useNotification } from '@hero/store/hooks';

const QualityApprovalWrapper = styled.div`
  text-align: left;

  ul {
    margin-top: var(--size-16);
    padding-left: var(--size-16);
    li {
      list-style-type: disc;
    }
  }
`;

function useShowEGiftCardRequireNotification() {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const { mutate: sendToApproval } = useSendToApproval();
  const { recognitionCode, code } = useParams();

  // const { code: automationCode } = useNewAutomationStore();

  const showEGiftCardNotification = () => {
    showNotification({
      message: (
        <QualityApprovalWrapper>
          <Trans i18nKey="eGiftCardApprovalDesc" components={{ b: <b /> }} />
          <ul>
            <li>
              <Trans i18nKey="eGiftCardApprovalBottomDescItem1" components={{ b: <b /> }} />
            </li>
            <li>
              <Trans i18nKey="eGiftCardApprovalBottomDescItem2" components={{ b: <b /> }} />
            </li>
            <li>
              <Trans i18nKey="eGiftCardApprovalBottomDescItem3" components={{ b: <b /> }} />
            </li>
            <li>
              <Trans i18nKey="eGiftCardApprovalBottomDescItem4" components={{ b: <b /> }} />
            </li>
          </ul>
        </QualityApprovalWrapper>
      ),
      header: t('eGiftCardApproval'),
      secondaryButtonProps: { children: t('cancel') },
      primaryButtonProps: {
        children: t('submitForApproval'),
        onClick: () =>
          sendToApproval({
            approveType: PRODUCT_TYPES.GIFT_CARD,
            payload: {
              associationCode: recognitionCode || code,
              associationType: recognitionCode ? 'recognition' : 'automation'
            }
          })
      }
    });
  };
  return { showEGiftCardNotification };
}

export { useShowEGiftCardRequireNotification };
